"use client";

import { usePathname, useRouter } from "@/i18n/navigation";
import { routing } from "@/i18n/routing";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useLocale, useTranslations } from "next-intl";
import { useParams } from "next/navigation";

export const LanguageSwitcher = () => {
  const translate = useTranslations("LanguageSwitcher");
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();

  const handleChangeLanguage = (event) => {
    router.replace({ pathname, params }, { locale: event.target.value });
  };

  return (
    <Select onChange={handleChangeLanguage} value={locale}>
      {routing.locales.map((cur) => (
        <MenuItem key={cur} value={cur}>
          {translate("locale", { locale: cur })}
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageSwitcher;
